import {v4 as uuidv4} from 'uuid'
import {characterData} from '../../components/character-picker';

class User {
  constructor(
    public id: string,
    public name: string
  ) { }
  static createNew() {
    const name = this.getRandomName()
    const id = uuidv4()

    return new User(id, name)
  }
  static getRandomName() {

    let characterOptions = characterData;

    var nameIndex = Math.floor(Math.random() * characterOptions.length);

    var nameAddition = Math.floor(Math.random() * 100) + 1;

    let createdName = characterOptions[nameIndex].userNameBase + nameAddition


    return createdName;
  }
}

export default User